import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Link, Navigate } from "react-router-dom";

const STATUS_COLORS = {
  pending: "bg-neutral-200 text-neutral-900",
  processing: "bg-amber-100 text-amber-900",
  shipped: "bg-blue-100 text-blue-900",
  delivered: "bg-emerald-100 text-emerald-900",
  cancelled: "bg-red-100 text-red-900",
  expired: "bg-neutral-300 text-neutral-400",
};

export default function Orders() {
  const { user, loading: authLoading } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    api.get("/orders/mine").then(({ data }) => setOrders(data)).finally(() => setLoading(false));
  }, [user]);

  if (authLoading) return <div className="p-10 font-mono">Loading…</div>;
  if (!user) return <Navigate to="/login" />;

  return (
    <main className="max-w-6xl mx-auto px-6 lg:px-10 py-16" data-testid="orders-page">
      <p className="overline opacity-60 mb-2">// Your orders</p>
      <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter mb-10">Order history</h1>
      {loading ? <p className="font-mono">Loading…</p> :
       orders.length === 0 ? (
        <div className="border border-white/10 p-10 bg-[#111111]">
          <p className="font-sans text-neutral-400 mb-6">You haven't placed any orders yet.</p>
          <Link to="/" className="btn-outline-dark">Start shopping</Link>
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div key={o.id} className="border border-white/10 bg-[#111111] p-5 grid md:grid-cols-6 gap-4 items-center"
                 data-testid={`order-${o.id}`}>
              <div className="md:col-span-2">
                <p className="font-mono text-xs opacity-50">#{o.id.slice(0, 8)}</p>
                <p className="font-display font-bold">{o.product_name}</p>
                <p className="font-mono text-xs opacity-60">Qty {o.quantity}</p>
              </div>
              <div className="font-mono text-sm">
                ${(o.amount / 100).toFixed(2)}
              </div>
              <div className="font-mono text-xs uppercase tracking-widest opacity-60">
                {o.fulfillment}
              </div>
              <div className="font-mono text-xs uppercase tracking-widest">
                {o.payment_method}
              </div>
              <div>
                <span className={`px-2 py-1 font-mono text-xs uppercase ${STATUS_COLORS[o.status] || "bg-neutral-200"}`}>
                  {o.status}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </main>
  );
}
